export default "__VITE_ASSET__CGE6Wo3s__"